<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Novo Departamento
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <label><span class="required">*</span> Departamento</label>
            <input
              v-model="department.title"
              type="text"
              class="form-control"
            >
          </div>
          <div class="col-md-3">
            <label>Gestor</label>
            <select
              v-model="department.menager"
              class="form-control"
            >
              <option
                v-for="user in users"
                :key="user.id"
                :value="user.id"
              >
                {{ user.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label>Empresa</label>
            <select
              v-model="department.company_id"
              class="form-control"
            >
              <option
                v-for="company in companies"
                :key="company.id"
                :value="company.id"
              >
                {{ company.company_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label><span class="required">*</span> Descrição</label>
            <input
              v-model="department.description"
              style="height: 100px"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="block text-right mt-2">
          <router-link
            to="/departments"
            class="btn btn-back"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-add ml-1"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      usersLoading: false,
      department: {
        title: '',
        description: '',
        menager: '',
      },
      companies: [],
    }
  },
  mounted() {
    const self = this

    const { id } = self.$route.params
    if (id) {
      self.getDepartment(id)
    }
    self.getUser()
    self.getCompanies()
  },
  methods: {
    save() {
      const self = this

      if (self.department.id) return self.edit()

      const api = `${this.$store.state.api}departments`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Departamento cadastrado com sucesso',
            'success',
          )
          this.$router.push('/departments')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    edit() {
      const self = this
      const api = `${self.$store.state.api}departments/${self.department.id}`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Departamento editado com sucesso',
            'success',
          )

          this.$router.push('/departments')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    makeFormData() {
      const self = this

      const fd = new FormData()

      fd.append('title', self.department.title)
      fd.append('description', self.department.description)
      fd.append('menager', self.department.menager)
      fd.append('company_id', self.department.company_id)

      console.log(self.department.menager)

      if (self.department.id) {
        fd.append('id', self.department.id)
        fd.append('_method', 'PUT')
      }

      return fd
    },
    getDepartment(id) {
      const self = this
      const api = `${self.$store.state.api}departments/${id}`

      axios
        .get(api)
        .then(response => {
          self.department = response.data.data[0]
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    getUser() {
      const self = this
      const api = `${self.$store.state.api}users`

      axios
        .get(api)
        .then(response => {
          console.log(response)
          self.usersLoading = true
          self.users = response.data.data
        })
        .catch(error => {
          // vm.$toast.error(error.response.data.message);
        })
    },
    getCompanies() {
      const self = this
      const api = `${self.$store.state.api}companies`

      axios
        .get(api)
        .then(response => {
          console.log(response)
          self.usersLoading = true
          self.companies = response.data.data
        })
        .catch(error => {
          // vm.$toast.error(error.response.data.message);
        })
    },
  },
}
</script>

<style scoped></style>
